<template>
  <div style="position: fixed; top: 12px; right: 12px; z-index: 1050">
    <LanguageSwitcher />
  </div>
  <div
    v-if="isLoading2 == true"
    style="
      font-weight: 800;
      border-radius: 10px;
      padding: 50px;
      font-size: large;
      text-align: center;
      background: #73737326;
    "
    class="loader text-success"
  >
    {{ $t("common.loading") }}
    <div class="spinner-border text-success" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
  <div class="d-flex flex-column flex-root" id="kt_app_root">
    <!--begin::Authentication - Sign-in -->
    <div class="d-flex flex-column flex-lg-row flex-column-fluid">
      <!--begin::Body-->
      <div
        class="d-flex flex-column flex-lg-row-fluid w-lg-50 order-2 order-lg-1"
        style="background: #fafafa"
      >
        <!--begin::Form-->
        <div class="d-flex flex-center flex-column flex-lg-row-fluid">
          <!--begin::Wrapper-->
          <div class="p-2 w-lg-500px" style="width: 90%">
            <!--begin::Form-->
            <div class="p-2">
              <h1 class="mb-5 text-center">{{ $t("common.login") }}</h1>
              <hr />
              <h1
                class="mb-5 text-center text-light"
                style="
                  font-weight: 700;
                  font-size: larger;
                  color: #29ca50 !important;
                "
              >
                {{ $t("common.app_name") }}
              </h1>
              <div class="loader-login-box text-center">
                <h6 style="color: #10ce36">{{ $t("common.please_wait") }}</h6>
                <div
                  class="spinner-border spinner-border-lg text-light"
                  role="status"
                  style="color: #6dff89 !important; height: 120px; width: 120px"
                >
                  <span class="sr-only">{{ $t("common.loading") }}</span>
                </div>
              </div>
              <form
                class="form-horizontal loginWithoutOtp"
                action="home.html"
                style="display: none"
              >
                <div style="min-height: 10px">
                  <span
                    id="error-message"
                    style="color: red; display: none; text-align: right"
                  >
                    {{ $t("auth.error_phone_required") }}</span
                  >
                  <div
                    id="cert-btn"
                    style="text-align: center; display: none"
                  ></div>
                </div>
                <div class="row" dir="rtl">
                  <div class="col-md-12">
                    <div
                      class="form-group form-group-custom mb-4"
                      id="phone-login-box"
                      dir="rtl"
                    >
                      <label class="text-right" for="phone">{{
                        $t("auth.phone")
                      }}</label>
                      <div class="input-group">
                        <input
                          type="tel"
                          class="form-control ml-1"
                          style="width: 100%"
                          id="phone"
                          maxlength="10"
                          max="9999999999"
                        />
                      </div>
                      <span
                        id="phone-error"
                        style="color: red; display: none"
                        >{{ $t("auth.error_phone_required") }}</span
                      >
                    </div>

                    <div class="form-group form-group-custom mb-4" dir="rtl">
                      <label for="password">{{ $t("auth.password") }}</label>
                      <input
                        type="password"
                        class="form-control"
                        id="password"
                        placeholder="..........."
                      />
                      <span
                        id="password-error"
                        style="color: red; display: none"
                      >
                        {{ $t("auth.error_password_required") }}</span
                      >
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <div class="text-md-right mt-3 mt-md-0">
                          <a
                            href=""
                            class="text-muted"
                            data-bs-toggle="modal"
                            data-bs-target="#forgetpassword-modal"
                            ><i class="fas fa-key"></i>
                            {{ $t("auth.forgot_password") }}</a
                          >
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div
                          class="text-md-right mt-3 mt-md-0 float-end"
                          style="margin-left: 12px"
                        >
                          <a
                            href=""
                            class="text-muted"
                            data-bs-toggle="modal"
                            data-bs-target="#retrieve-device-modal"
                            ><i class="fas fa-mobile-alt"></i>
                            {{ $t("auth.lost_my_device") }}
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="d-grid gap-2">
                      <div class="mt-4 login">
                        <button
                          class="p-3 btn btn-success btn-block waves-effect waves-light"
                          style="height: 55px; font-size: 19px; width: 100%"
                          type="button"
                          @click="login()"
                        >
                          {{ $t("common.login") }}
                          <i class="fas fa-sign-in-alt"></i>
                        </button>
                      </div>
                    </div>

                    <hr />
                    <div class="row" dir="rtl">
                      <div class="col-md-6 col-6">
                        <div class="mt-2 text-right">
                          <a
                            href=""
                            data-bs-toggle="modal"
                            data-bs-target="#qr-code-modal"
                            class="text-muted"
                            ><i class="fas fa-qrcode"></i>
                            {{ $t("auth.qr_code") }}</a
                          >
                        </div>
                      </div>
                      <div class="col-md-6 col-6">
                        <div
                          class="mt-2 text-left float-end"
                          style="margin-left: 12px"
                        >
                          <a href="register" class="text-muted"
                            ><i class="fas fa-user-plus"></i>
                            {{ $t("auth.create_account_title") }}</a
                          >
                        </div>
                      </div>
                      <br />
                      <br />

                      <div class="col-md-8 col-8">
                        <div class="mt-2 text-right" style="margin-left: 12px">
                          <a
                            href="privacy-policy"
                            target="_blank"
                            class="text-muted"
                            ><i class="fas fa-shield-alt"></i>
                            {{ $t("common.privacy_policy") }}
                          </a>
                          |
                          <a
                            href="terms-of-service"
                            target="_blank"
                            class="text-muted"
                            ><i class="fas fa-file-contract"></i>
                            {{ $t("common.terms_of_service") }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!--end::Wrapper-->
        </div>
        <!--end::Form-->
        <!--begin::Footer-->
        <div class="w-lg-500px d-flex flex-stack px-10 mx-auto">
          <!--begin::Languages-->
          <div class="me-10"></div>
          <!--end::Languages-->
        </div>
        <!--end::Footer-->
      </div>
      <!--end::Body-->
      <!--begin::Aside-->
      <div
        class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
        style="background: #fff"
      >
        <!--begin::Content-->
        <div
          class="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100"
        >
          <!--begin::Logo-->
          <a href="#" class="mb-0 mb-lg-12">
            <img
              alt="Logo"
              src="assets/img/logo-dark.png"
              class="h-60px h-lg-75px"
            />
          </a>
          <!--end::Logo-->
          <!--begin::Image-->
          <img
            class="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20"
            src="assets/img/learningv2.gif"
            alt=""
          />
          <!--end::Image-->
          <!--begin::Title-->
          <h1
            class="d-none d-lg-block text-success fs-2qx fw-bolder text-center mb-7"
          >
            {{ $t("auth.tagline") }}
          </h1>
          <!--end::Title-->
          <!--begin::Text-->

          <div class="d-none d-lg-block text-success fs-base text-center">
            {{ $t("auth.promo_text") }}
          </div>
          <!--end::Text-->
        </div>
        <!--end::Content-->
      </div>
      <!--end::Aside-->
    </div>
    <!--end::Authentication - Sign-in-->

    <div
      dir="rtl"
      class="modal fade qr-code-modal"
      id="qr-code-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              {{ $t("auth.qr_login_title") }}
            </h5>
          </div>
          <div class="modal-body">
            <h4 class="mb-2 text-center">{{ $t("auth.qr_login_desc") }}</h4>
            <div
              class="qr-code-box"
              id="qrcode"
              style="
                width: 150px;
                height: 150px;
                margin-top: 15px;
                margin: 0 auto;
              "
            ></div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              {{ $t("common.cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ForgotPassword />
  <LostMyDevice />
  <VerifyAccount />

  <!---------------Forgot Password Modal----------------------------------------->
</template>
<script>
import { hashV2 } from "@/utils/api";
import QRCode from "qrcodejs2";
import ForgotPassword from "./auth/ForgotPassword.vue";
import LostMyDevice from "./auth/LostMyDevice.vue";
import VerifyAccount from "./auth/VerifyAccount.vue";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";

import { apiUrl, deviceId, baseUrl, getBrowserName } from "@/utils/api"; // Adjust the import path according to your project structure
import { backupAuthValue } from "@/utils/cookieBackup";
// Adjust the import path according to your project structure
var iti;

export default {
  name: "Login",
  components: {
    ForgotPassword,
    LostMyDevice,
    VerifyAccount,
    LanguageSwitcher,
  },
  data() {
    return {
      phoneOtpError: false,
      phoneError: false,
      errorMessage: "",
      isLoading2: true,
    };
  },
  mounted() {
    localStorage.removeItem("access_token_vr");
    // Always show login form - no redirect
    this.isLoading2 = false;
    this.initLoginForm();
  },
  methods: {
    login() {
      const $loginBtn = $(".login button");
      const $phoneErrorElem = $("#phone-error");
      const $passwordErrorElem = $("#password-error");
      const $errorMessageElem = $("#error-message");

      $phoneErrorElem.hide();
      $passwordErrorElem.hide();
      $errorMessageElem.hide();

      const mobile = $("#phone").val();
      const password = $("#password").val();
      const platform = "web";
      const version = "11.0.0";

      if (!mobile) {
        $phoneErrorElem.show();
        return;
      }
      if (!password) {
        $passwordErrorElem.show();
        return;
      }

      // Show the loading spinner
      $loginBtn.html(
        '<div class="spinner-border spinner-border-lg text-light" role="status"><span class="sr-only">Loading...</span></div>'
      );

      const payload = {
        mobile: iti.getNumber(),
        country_code: "+" + iti.getSelectedCountryData().dialCode,

        password,
        platform,
        version,
      };

      $.ajax({
        url: apiUrl + "/login/web",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          Authorization: "Bearer oeKNF8MEnoTtcaCOAcr0XT7dYQgnLXUsiyTNyGvY",
        },
        data: payload,
      })
        .done((response) => {
          if (response.message) {
            $errorMessageElem.text(response.message).show();
          } else if (response.access_token) {
            // Store access token
            localStorage.setItem("access_token_vr", response.access_token);
            backupAuthValue("access_token_vr", response.access_token);

            // بعد ما نخزن الـ token نعمل له call جديد على /home/web
            $.ajax({
              url: apiUrl + "/home/web",
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization:
                  "Bearer " + localStorage.getItem("access_token_vr"),
              },
            }).done((homeResponse) => {
              localStorage.setItem("access_token", response.access_token);
              backupAuthValue("access_token", response.access_token);
              // alert(localStorage.getItem("access_token"));
              // هنا يعتمد على قيمة is_verified
              if (homeResponse.is_verfied === false) {
                // عرض المودال
                const modal = new bootstrap.Modal(
                  document.getElementById("user-verification-modal")
                );
                modal.show();
                return;
                /*localStorage.setItem("access_token", response.access_token);
                localStorage.setItem("expires_in", response.expires_in);

                window.location.href = "/home";*/
                localStorage.setItem("access_token", response.access_token);
                backupAuthValue("access_token", response.access_token);
                localStorage.setItem("expires_in", response.expires_in);
                backupAuthValue("expires_in", response.expires_in);

                window.location.href = "/home";
              } else {
                // توجيه في حالة verified
                localStorage.setItem("access_token", response.access_token);
                backupAuthValue("access_token", response.access_token);
                localStorage.setItem("expires_in", response.expires_in);
                backupAuthValue("expires_in", response.expires_in);

                window.location.href = "/home";
              }
            });
          }
        })

        .fail((response) => {
          const res = response.responseJSON;
          if (res.message) {
            $errorMessageElem.text(res.message).show();
            if (response.status == 406) {
              $("#cert-btn")
                .html(
                  "<a href=" +
                    baseUrl +
                    'login-verify-users" target="_blank" class="btn btn-sm btn-success text-center cert- mt-2"><i class="fa fa-arrow-right"></i>  توثيق الأن  </a>'
                )
                .show();
            }
          }
        })
        .always(() => {
          // Restore the original button text after the request is done
          $loginBtn.html(
            'تسجيل دخول <i class="mdi mdi-application-export"></i>'
          );
        });
    },
    // End Update By Alfaqieh 27/7/2023

    initLoginForm() {
      const self = this;
      $(document).ready(function () {
        // Clear any existing QR code first
        const qrcodeElement = document.getElementById("qrcode");
        if (qrcodeElement) {
          qrcodeElement.innerHTML = "";
        }
        var qrcode = new QRCode(qrcodeElement, {
          width: 150,
          height: 150,
        });

        qrcode.makeCode(deviceId + "//" + getBrowserName());
        $(".loginWithoutOtp").hide();
        $(".loginWithOtp").hide();
        $.ajax({
          url: apiUrl + "/home/web",
          method: "GET",
          dataType: "json",
          success: function (response) {
            $(".loader-login-box").hide();

            var otpStatus = 0;
            var phone;
            if (otpStatus == 0) {
              $(".loginWithoutOtp").show();
              $(".loginWithOtp").hide();
              phone = document.querySelector("#phone");
            }
            if (otpStatus == 1) {
              $(".loginWithoutOtp").hide();
              $(".loginWithOtp").show();
              phone = document.querySelector("#phoneOtp");
            }
            iti = intlTelInput(phone, {
              utilsScript: "assets/js/utils.js",
              initialCountry: "ly",
              separateDialCode: true,
              excludeCountries: ["il"],
              nationalMode: true,
              formatOnDisplay: false,
              customPlaceholder: function (
                selectedCountryPlaceholder,
                selectedCountryData
              ) {
                // Remove leading 0 from placeholder (e.g., 0922345678 -> 922345678)
                return selectedCountryPlaceholder.replace(/^0/, "");
              },
            });

            // Handle browser autofill - clean the phone value after initialization
            setTimeout(() => {
              if (phone.value) {
                // Remove any non-digit characters that autofill might have added
                const cleanedValue = phone.value.replace(/\D/g, "");
                if (cleanedValue !== phone.value) {
                  phone.value = cleanedValue;
                }
              }
            }, 100);
          },
          error: function (error) {},
        });

        document.querySelector("#phone").addEventListener("keyup", (event) => {
          if (event.keyCode === 13) {
            self.login();
          }
        });

        document
          .querySelector("#password")
          .addEventListener("keyup", (event) => {
            if (event.keyCode === 13) {
              self.login();
            }
          });

        document
          .querySelector("#phone")
          .addEventListener("input", function (ev) {
            var maxlength = this.getAttribute("max").length;
            var value = this.value;
            if (value && value.length >= maxlength) {
              this.value = value.substr(0, maxlength);
            }
          });
      });
    },
  },
};
</script>
<style scoped>
/* ========== Animations ========== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes bubbleFloat {
  0%,
  100% {
    transform: translateY(0) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-20px) scale(1.1);
    opacity: 0.8;
  }
}

@keyframes bubbleFloat2 {
  0%,
  100% {
    transform: translateY(0) translateX(0) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: translateY(-30px) translateX(10px) scale(1.15);
    opacity: 0.7;
  }
}

@keyframes bubbleFloat3 {
  0%,
  100% {
    transform: translateY(0) translateX(0) scale(1);
    opacity: 0.4;
  }
  50% {
    transform: translateY(-15px) translateX(-10px) scale(1.05);
    opacity: 0.6;
  }
}

/* ========== Main Container ========== */
#kt_app_root {
  min-height: 100vh;
  background: #ffffff;
  position: relative;
  overflow: hidden;
}

@keyframes circleFloat1 {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(40px, 30px);
  }
}

@keyframes circleFloat2 {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-30px, 40px);
  }
}

@keyframes circleFloat3 {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(25px, -35px);
  }
}

@keyframes circleFloat4 {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-40px, -25px);
  }
}

/* ========== Left Side - Form ========== */
.d-flex.flex-column.flex-lg-row-fluid.w-lg-50.order-2.order-lg-1 {
  background: #f5f5f5 !important;
  position: relative;
  z-index: 1;
  overflow: hidden;
}

/* Multiple floating circles on left side only */
.d-flex.flex-column.flex-lg-row-fluid.w-lg-50.order-2.order-lg-1::before {
  content: "";
  position: absolute;
  width: 250px;
  height: 250px;
  background: rgba(0, 196, 68, 0.1);
  border-radius: 50%;
  top: -50px;
  left: -50px;
  pointer-events: none;
  animation: circleFloat1 10s ease-in-out infinite;
}

.d-flex.flex-column.flex-lg-row-fluid.w-lg-50.order-2.order-lg-1::after {
  content: "";
  position: absolute;
  width: 180px;
  height: 180px;
  background: rgba(0, 196, 68, 0.08);
  border-radius: 50%;
  bottom: 10%;
  left: 20%;
  pointer-events: none;
  animation: circleFloat2 12s ease-in-out infinite;
}

/* Additional circles using box-shadow trick */
.d-flex.flex-center.flex-column.flex-lg-row-fluid {
  position: relative;
}

.d-flex.flex-center.flex-column.flex-lg-row-fluid::before {
  content: "";
  position: absolute;
  width: 120px;
  height: 120px;
  background: rgba(0, 196, 68, 0.07);
  border-radius: 50%;
  top: 20%;
  right: 5%;
  pointer-events: none;
  animation: circleFloat3 8s ease-in-out infinite;
}

.d-flex.flex-center.flex-column.flex-lg-row-fluid::after {
  content: "";
  position: absolute;
  width: 200px;
  height: 200px;
  background: rgba(0, 196, 68, 0.06);
  border-radius: 50%;
  bottom: -30px;
  right: -30px;
  pointer-events: none;
  animation: circleFloat4 14s ease-in-out infinite;
}

/* ========== Form Wrapper ========== */
.p-2.w-lg-500px {
  animation: fadeInUp 0.8s ease forwards;
  position: relative;
  z-index: 1;
}

.p-2.w-lg-500px > .p-2 {
  background: #ffffff;
  border: none;
  border-radius: 24px;
  padding: 40px 32px !important;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.1), 0 10px 30px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

/* Decorative top accent line */
.p-2.w-lg-500px > .p-2::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(
    90deg,
    #00c444,
    #00e050,
    #00ff6a,
    #00e050,
    #00c444
  );
  background-size: 200% 100%;
  animation: shimmer 3s linear infinite;
}

/* Decorative corner accent */
.p-2.w-lg-500px > .p-2::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 100px;
  background: radial-gradient(
    circle at top right,
    rgba(0, 196, 68, 0.08) 0%,
    transparent 70%
  );
  pointer-events: none;
}

/* ========== Titles ========== */
.p-2 > h1.mb-5.text-center:first-of-type {
  font-size: 2rem !important;
  font-weight: 800 !important;
  color: #1a1a2e !important;
  margin-bottom: 16px !important;
}

.p-2 > hr {
  border: none;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(0, 196, 68, 0.4),
    transparent
  );
  margin: 20px 0;
}

.p-2 > h1.text-light {
  font-size: 1.5rem !important;
  color: #00c444 !important;
  font-weight: 700 !important;
}

/* ========== Loading Spinner ========== */
.loader-login-box {
  padding: 40px 0;
}

.loader-login-box h6 {
  color: #00e050 !important;
  font-size: 1.1rem;
  margin-bottom: 20px;
  text-shadow: 0 0 20px rgba(0, 224, 80, 0.5);
}

.loader-login-box .spinner-border {
  color: #00e050 !important;
  width: 80px !important;
  height: 80px !important;
  border-width: 4px;
  animation: pulse 1.5s ease infinite;
}

/* ========== Form Controls ========== */
.form-control {
  height: 55px;
  font-size: 17px;
  width: 100%;
  background: #ffffff !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 14px !important;
  color: #1a1a2e !important;
  padding: 12px 16px;
  padding-right: 45px;
  transition: all 0.3s ease;
}

.form-control::placeholder {
  color: #9ca3af;
}

.form-control:focus {
  background: #ffffff !important;
  border-color: #00c444 !important;
  box-shadow: 0 0 0 4px rgba(0, 196, 68, 0.1) !important;
  outline: none;
}

/* ========== Labels with Icons ========== */
.form-group-custom {
  position: relative;
}

.form-group-custom label {
  color: #374151 !important;
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-group-custom label::before {
  font-family: "Font Awesome 6 Free", "Font Awesome 5 Free", FontAwesome;
  font-weight: 900;
  font-size: 1rem;
  color: #00c444;
}

/* Phone icon */
#phone-login-box label::before {
  content: "\f095";
}

/* Password icon */
.form-group-custom:not(#phone-login-box) label[for="password"]::before {
  content: "\f023";
}

/* ========== Login Button ========== */
.login button.btn-success {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%) !important;
  border: none !important;
  border-radius: 14px !important;
  font-size: 1.2rem !important;
  font-weight: 700 !important;
  height: 60px !important;
  box-shadow: 0 8px 30px rgba(0, 224, 80, 0.3);
  transition: all 0.3s ease !important;
  position: relative;
  overflow: hidden;
}

.login button.btn-success::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}

.login button.btn-success:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(0, 224, 80, 0.4);
}

.login button.btn-success:hover::before {
  left: 100%;
}

/* ========== Links ========== */
.text-muted {
  color: #6b7280 !important;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.95rem;
}

.text-muted:hover {
  color: #00c444 !important;
}

/* Link icons - Font Awesome */
.text-muted i.fas {
  font-size: 1rem;
  color: #00c444;
  margin-left: 6px;
}

.text-muted:hover i.fas {
  color: #00a838;
}

/* ========== Right Side - Branding ========== */
.d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 {
  background: #ffffff !important;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

/* ========== Logo ========== */
.d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 a.mb-0.mb-lg-12 img {
  filter: drop-shadow(0 10px 30px rgba(0, 196, 68, 0.2));
  transition: all 0.3s ease;
}

.d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 a.mb-0.mb-lg-12:hover img {
  transform: scale(1.05);
  filter: drop-shadow(0 15px 40px rgba(0, 196, 68, 0.3));
}

/* ========== Illustration ========== */
.d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 img.mx-auto {
  animation: float 4s ease-in-out infinite;
  filter: none;
}

/* ========== Tagline ========== */
.d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 h1.text-success {
  color: #00c444 !important;
  font-weight: 800 !important;
  text-shadow: 0 4px 20px rgba(0, 196, 68, 0.2);
}

.d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 .text-success.fs-base {
  color: #047857 !important;
  font-size: 1.1rem !important;
  line-height: 1.8;
}

/* ========== Modal Styling ========== */
.modal-content {
  background: #ffffff !important;
  border: 1px solid rgba(0, 196, 68, 0.15) !important;
  border-radius: 20px !important;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.15);
}

.modal-header {
  border-bottom: 1px solid #e5e7eb !important;
  padding: 20px 24px;
}

.modal-title {
  color: #1a1a2e !important;
  font-weight: 700;
}

.modal-body {
  padding: 24px;
}

.modal-body h4 {
  color: #374151 !important;
}

.modal-footer {
  border-top: 1px solid #e5e7eb !important;
  padding: 16px 24px;
}

.modal-footer .btn-secondary {
  background: #f3f4f6 !important;
  border: 1px solid #e5e7eb !important;
  color: #374151 !important;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.modal-footer .btn-secondary:hover {
  background: #e5e7eb !important;
}

/* ========== QR Code Box ========== */
.qr-code-box {
  background: #fff;
  padding: 15px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* ========== Language Switcher ========== */
div[style*="position: fixed; top: 12px; right: 12px"] {
  z-index: 1050;
}

/* ========== Error Messages ========== */
#error-message,
#phone-error,
#password-error {
  display: block;
  color: #ef4444 !important;
  font-size: 0.85rem;
  font-weight: 500;
  margin-top: 8px;
  padding: 0;
  background: transparent;
  border: none;
  text-align: right;
}

/* ========== International Phone Input ========== */
.iti {
  width: 100%;
}

.iti__flag-container {
  background: #f8f9fa;
  border-radius: 14px 0 0 14px;
}

.iti__selected-flag {
  background: transparent !important;
  border-radius: 14px 0 0 14px;
}

.iti__selected-dial-code {
  color: #00c444 !important;
}

/* ========== Responsive ========== */
@media (max-width: 991.98px) {
  .p-2.w-lg-500px > .p-2 {
    padding: 30px 20px !important;
    border-radius: 20px;
    margin: 20px;
  }

  .d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 {
    padding: 30px 20px !important;
  }
}
</style>
